import AOS from 'aos';

AOS.init({
    once: true,
    offset: 100,
    startEvent: 'load',
});
AOS.refresh(true);

$(window).on('scroll', function () {
  AOS.refresh();
});

// set transition delay to zero
$(document).on('mouseover', '.aos-animate.aos-init', function () {
  $(this).addClass('aos-animation-ready');
});

// fix for Safari back button cache issue with playing video
window.onpageshow = function (event) {
  if (event.persisted) {
      window.location.reload();
  }
};

// check the first three sections and add an offset to each aos effect so that it is immediately visible on mobile when on top of page
if ($(window).width() < 992) {
  $('main.main section:lt(3)').each(function(){
    $(this).find('[data-aos]').attr('data-aos-offset', '-100');
  });
}
